import React, { useEffect } from 'react';
import './conteudo-painel-componentes.component.scss';
import { Box, Button, FormControl, InputLabel, Menu, MenuItem, Select, SelectChangeEvent, Tabs, TextField } from '@mui/material';
import Tab from '@mui/material/Tab';
import { useInput } from '../../hooks/useInput.hook';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import MenuModel, { ItensMenuModel } from '../../models/menu.model';
import { CONSTANTS } from '../../constants/constants';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddIcon from '@mui/icons-material/Add';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CamposMenuComponent from '../campos-menu/campos-menu.component';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import { ComponentsModel } from '../../models/layout.model';
import SessaoModel from '../../models/sessao.model';
import CarrosselModel from '../../models/carrossel.model';
import ContatoModel from '../../models/contato.model';
import GaleriaModel from '../../models/galeria.model';
import CamposComponenteSessaoComponent from '../campos-componente-sessao/campos-componente-sessao.component';
import CamposComponenteContatoComponent from '../campos-componente-contato/campos-componente-contato.component';
import CamposComponenteCarrosselComponent from '../campos-componente-carrossel/campos-componente-carrossel.component';
import CamposComponenteGaleriaComponent from '../campos-componente-galeria/campos-componente-galeria.component';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type ConteudoPainelComponentesComponentProps = {
  setVal: (val: ComponentsModel[]) => void;
  componentes?: ComponentsModel[];
  menu: ItensMenuModel[];
}

function ConteudoPainelComponentesComponent(props: ConteudoPainelComponentesComponentProps) {

  const [itensComponents, updateItensComponents] = React.useState<any>(props.componentes ? props.componentes : []);

  const [valueTabs, setValueTabs] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const [menuInput, setMenuInput] = React.useState('todos');
  const [menuInputFiltro, setMenuInputFiltro] = React.useState('todos');

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  useEffect(() => {
    atualizaComponentes();
  }, [itensComponents]);

  const addComponente = (tipo: string) => {
    const items = [...itensComponents];
    let newItem: ComponentsModel = {
      tipo: ''
    };

    if (tipo === CONSTANTS.TIPO_COMPONENTE.SESSAO) {
      newItem = {
        tipo: CONSTANTS.TIPO_COMPONENTE.SESSAO,
        id: 'id_drag-' + itensComponents.length,
        sessao: {
          id: '',
          titulo: '',
          descricao: '',
          alinhamento_titulo: CONSTANTS.ALINHAMENTO.ESQUERDA,
          alinhamento_descricao: CONSTANTS.ALINHAMENTO.ESQUERDA,
          imagem: '',
          layout: CONSTANTS.LAYOUT_SESSAO.IMG_ESQ,
          full: false,
          bg: '',
          cor_do_titulo: '#000',
          cor_do_texto: '#000',
          texto_botao: '',
          url_botao: '',
          tipo_botao: CONSTANTS.TIPO_BOTAO.LINK_EXTERNO,
          cor_texto_botao: '#000',
          cor_bg_botao: '#ccc'
        }
      };
    } else if (tipo === CONSTANTS.TIPO_COMPONENTE.CARROSSEL) {
      newItem = {
        tipo: CONSTANTS.TIPO_COMPONENTE.CARROSSEL,
        id: 'id_drag-' + itensComponents.length,
        carrossel: {
          id: '',
          titulo: '',
          descricao: '',
          qtd_por_slide: 1,
          bg: '#fff',
          cor_do_titulo: '#000',
          cor_do_texto: '#000',
          cor_de_fundo_legenda: '#fff',
          cor_do_texto_legenda: '#000',
          cor_do_bullets: '#000',
          cor_da_borda: '#ccc',
          loop: false,
          autoplay: false,
          full: true,
          borda_arredondada: false,
          itens: []
        }
      };
    } else if (tipo === CONSTANTS.TIPO_COMPONENTE.CONTATO) {
      newItem = {
        tipo: CONSTANTS.TIPO_COMPONENTE.CONTATO,
        id: 'id_drag-' + itensComponents.length,
        contato: {
          id: '',
          titulo: '',
          descricao: '',
          endereco: '',
          iframe: '',
          bg: '#fff',
          cor_do_titulo: '#000',
          cor_do_texto: '#000',
          cor_do_campo: '#000',
          cor_efeito_do_campo: '#000',
          cor_texto_do_botao: '#fff',
          cor_fundo_do_botao: '#000',
          email_para_envio_do_formulario: ''
        }
      };
    } else if (tipo === CONSTANTS.TIPO_COMPONENTE.GALERIA) {
      newItem = {
        tipo: CONSTANTS.TIPO_COMPONENTE.GALERIA,
        id: 'id_drag-' + itensComponents.length,
        galeria: {
          id: '',
          titulo: '',
          descricao: '',
          itens: [],
          bg: '#fff',
          cor_do_titulo: '#000',
          cor_do_texto: '#000'
        }
      };
    }

    items.push(newItem);
    updateItensComponents(items);
    setAnchorEl(null);
  };

  const handleOnDragEnd = (result: any) => {

    const items = Array.from(itensComponents);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    updateItensComponents(items);
  }

  const handleChageItemMenu = (item: ComponentsModel) => {

    const items = [...itensComponents];
    const itemEncontrado: ComponentsModel = items.find(
      a => a.id === item.id
    );
    itemEncontrado.id = item.id;
    itemEncontrado.tipo = item.tipo;
    itemEncontrado.sessao = item.sessao;
    itemEncontrado.carrossel = item.carrossel;
    itemEncontrado.contato = item.contato;
    itemEncontrado.galeria = item.galeria;
    updateItensComponents(items);
  }

  const removerItemMenu = (id?: string) => {
    updateItensComponents(
      itensComponents.filter(a =>
        a.id !== id
      )
    );
  }

  const atualizaComponentes = () => {
    props.setVal(itensComponents);
  }

  return (
    <section className="conteudo-painel-componentes">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTabs}
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <h2>Componentes</h2>

          {
            props.menu &&
            <div className="campo w100">
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
                <InputLabel id="demo-select-small-label">Filtrar por menu</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={menuInput}
                  label="Submenu"
                  onChange={(event) => {
                    setMenuInput(event.target.value);
                    if (event.target.value === ',') {
                      setMenuInputFiltro('');
                    } else {
                      setMenuInputFiltro(event.target.value);
                    }
                  }}
                >
                  <MenuItem value="todos">
                    <em>Todos</em>
                  </MenuItem>
                  {
                    props.menu?.map((item, iMenu) => (
                      <MenuItem key={iMenu} value={item.id_do_componente == '' ? ',' : item.id_do_componente}>{item.nome}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </div>
          }

          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="itens-componentes">
              {(provided) => (
                <div className="itens-componentes" {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    itensComponents?.map((item: ComponentsModel, iMenu) => (
                      <React.Fragment key={iMenu}>
                        {
                          (
                            (item.tipo === CONSTANTS.TIPO_COMPONENTE.SESSAO && (item.sessao?.id.split(',').includes(menuInputFiltro) || menuInputFiltro === 'todos')) ||
                            (item.tipo === CONSTANTS.TIPO_COMPONENTE.CONTATO && (item.contato?.id.split(',').includes(menuInputFiltro) || menuInputFiltro === 'todos')) ||
                            (item.tipo === CONSTANTS.TIPO_COMPONENTE.CARROSSEL && (item.carrossel?.id.split(',').includes(menuInputFiltro) || menuInputFiltro === 'todos')) ||
                            (item.tipo === CONSTANTS.TIPO_COMPONENTE.GALERIA && (item.galeria?.id.split(',').includes(menuInputFiltro) || menuInputFiltro === 'todos'))
                          ) &&
                          <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                            {(provided) => (
                              <Accordion ref={provided.innerRef} {...provided.draggableProps} >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={item.id + '-content'}
                                  id={item.id + '-header'}
                                  {...provided.dragHandleProps}
                                >
                                  <Typography component="span"><OpenWithIcon /> {item.tipo + ' - '}
                                    {
                                      item.tipo === CONSTANTS.TIPO_COMPONENTE.SESSAO &&
                                      <i>{item.sessao?.titulo}</i>
                                    }
                                    {
                                      item.tipo === CONSTANTS.TIPO_COMPONENTE.CARROSSEL &&
                                      <i>{item.carrossel?.titulo}</i>
                                    }
                                    {
                                      item.tipo === CONSTANTS.TIPO_COMPONENTE.CONTATO &&
                                      <i>{item.contato?.titulo}</i>
                                    }
                                    {
                                      item.tipo === CONSTANTS.TIPO_COMPONENTE.GALERIA &&
                                      <i>{item.galeria?.titulo}</i>
                                    }
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  {
                                    (item.tipo === CONSTANTS.TIPO_COMPONENTE.SESSAO) &&
                                    <CamposComponenteSessaoComponent
                                      componente={item}
                                      setVal={(val) => handleChageItemMenu(val)}
                                      removeItem={(id) => removerItemMenu(id)}
                                      menu={props.menu}
                                    />
                                  }

                                  {
                                    (item.tipo === CONSTANTS.TIPO_COMPONENTE.CONTATO) &&
                                    <CamposComponenteContatoComponent
                                      componente={item}
                                      setVal={(val) => handleChageItemMenu(val)}
                                      removeItem={(id) => removerItemMenu(id)}
                                      menu={props.menu}
                                    />
                                  }

                                  {
                                    (item.tipo === CONSTANTS.TIPO_COMPONENTE.CARROSSEL) &&
                                    <CamposComponenteCarrosselComponent
                                      componente={item}
                                      setVal={(val) => handleChageItemMenu(val)}
                                      removeItem={(id) => removerItemMenu(id)}
                                      menu={props.menu}
                                    />
                                  }

                                  {
                                    (item.tipo === CONSTANTS.TIPO_COMPONENTE.GALERIA) &&
                                    <CamposComponenteGaleriaComponent
                                      componente={item}
                                      setVal={(val) => handleChageItemMenu(val)}
                                      removeItem={(id) => removerItemMenu(id)}
                                      menu={props.menu}
                                    />
                                  }
                                </AccordionDetails>
                              </Accordion>
                            )}
                          </Draggable>
                        }
                      </React.Fragment>
                    ))
                  }
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="bts">
            <Button
              className='bt add'
              //onClick={addMenu}
              id="basic-button"
              aria-controls={openMenu ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openMenu ? 'true' : undefined}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            ><AddIcon />Adicionar componente</Button>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={() => { setAnchorEl(null) }}
            >
              <MenuItem onClick={() => addComponente(CONSTANTS.TIPO_COMPONENTE.SESSAO)}>Sessão</MenuItem>
              <MenuItem onClick={() => addComponente(CONSTANTS.TIPO_COMPONENTE.CARROSSEL)}>Carrossel</MenuItem>
              <MenuItem onClick={() => addComponente(CONSTANTS.TIPO_COMPONENTE.CONTATO)}>Contato</MenuItem>
              <MenuItem onClick={() => addComponente(CONSTANTS.TIPO_COMPONENTE.GALERIA)}>Galeria</MenuItem>
            </Menu>
          </div>
        </CustomTabPanel>
      </Box>
    </section>
  );
}

export default ConteudoPainelComponentesComponent;
